import React, { useState } from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from "reactstrap"
import SimpleBar from "simplebar-react"
import { useSelector, useDispatch, connect } from "react-redux"
import { setActiveOrganization } from "../../../store/Organization/actions"

//i18n
import { withTranslation } from "react-i18next"

const OrganizationDropDown = props => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false)
  const organizations = useSelector(
    state => state.organizationReducer.organizations,
  )
  const activeOrganization = useSelector(
    state => state.organizationReducer.activeOrganization,
  )

  const dispatch = useDispatch()

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="dropdown d-inline-block ms-1"
        tag="li"
      >
        <DropdownToggle
          className="btn header-item noti-icon waves-effect"
          tag="button"
          id="page-header-notifications-dropdown"
        >
          <i className="mdi mdi-domain"></i>
          {/* <span className="badge text-bg-danger rounded-pill">3</span> */}
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0">
          <div className="p-3">
            <Row className="align-items-center">
              <Col>
                <h5 className="m-0">
                  {" "}
                  {props.t("Organizations")} ({organizations.length}){" "}
                </h5>
              </Col>
            </Row>
          </div>

          <SimpleBar style={{ height: "230px" }}>
            {organizations.map((org, index) => (
              <Link
                to="#"
                className="text-reset notification-item"
                key={index}
                onClick={() => {
                  dispatch(setActiveOrganization(org.Organization))
                }}
              >
                <div className="d-flex">
                  <div className="flex-shrink-0 me-3">
                    <div className="avatar-xs me-3">
                      {org?.Organization?.id === activeOrganization?.id ? (
                        <span className="avatar-title border-success rounded-circle">
                          <img
                            src={org?.Organization?.logo}
                            alt="logo"
                            className="company-dropdown-logo"
                          />
                        </span>
                      ) : (
                        <span className="avatar-title border-warning rounded-circle">
                          <img
                            src={org?.Organization?.logo}
                            alt="logo"
                            className="company-dropdown-logo"
                          />
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="flex-grow-1">
                    <h6 className="mt-0 mb-1">
                      {org?.Organization?.name}
                      {/* {"  "} */}
                      {/* Render the green dot if it's the active organization */}
                      {/* {org.Organization.id === activeOrganization.id && (
                        <span
                          style={{
                            display: "inline-block",
                            width: "8px",
                            height: "8px",
                            backgroundColor: "green",
                            borderRadius: "50%",
                            marginRight: "8px",
                          }}
                        ></span>
                      )} */}
                    </h6>
                    <div className="text-muted">
                      <p className="mb-1">{org?.Organization?.address}</p>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </SimpleBar>
          {/* <div className="p-2 border-top d-grid">
            <Link
              className="btn btn-sm btn-link font-size-14 btn-block text-center"
              to="/organizations-list"
            >
              <i className="mdi mdi-arrow-right-circle me-1"></i>{" "}
              {props.t("View all")}{" "}
            </Link>
          </div> */}
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  )
}

export default withTranslation()(OrganizationDropDown)

OrganizationDropDown.propTypes = {
  t: PropTypes.any,
}
